import React, { forwardRef } from "react";
import { SbEmpty } from "uiCore";
import { getRoleCountCards } from "../orgDesign.constants";
import { SummaryTabStyled, SummarySectionsStyled, SummarySectionTitleStyled } from "../orgDesign.styles";
import OrgDesignBudgetBar from "./OrgDesignBudgetBar";
import OrgDesignSummaryBridge from "./OrgDesignSummaryBridge";
import OrgDesignRoleCount from "./OrgDesignRoleCount";

const SummarySection = ({ title, children }) => (
  <section>
    <SummarySectionTitleStyled>{title}</SummarySectionTitleStyled>
    {children}
  </section>
);

// The workspace's Summary tab: every figure for the design, in the same
// sections as the PDF's Summary page. Budget shows only with `canViewBudget`
// (the view_comp entitlement). Each section shows only once its figures
// exist, the same rule the PDF follows. `ref` marks the figures for the
// guided tour's Summary step.
const OrgDesignSummaryTab = forwardRef(({ draft, canViewBudget, budgetSyncing, onSetTargetBudget }, ref) => {
  const roleCountCards = getRoleCountCards(draft.roleCounts, draft.entryOption);
  const hasFigures = canViewBudget || !!draft.stats || roleCountCards.length > 0;

  return (
    <SummaryTabStyled>
      <SummarySectionsStyled ref={ref}>
        {canViewBudget && (
          <SummarySection title="Budget">
            <OrgDesignBudgetBar
              baselineBudget={draft.baseline_budget}
              targetBudget={draft.targetBudget}
              projectedBudget={draft.projected_budget}
              onSetTargetBudget={onSetTargetBudget}
              syncing={budgetSyncing}
            />
          </SummarySection>
        )}

        {draft.stats && (
          <SummarySection title="Headcount bridge">
            <OrgDesignSummaryBridge stats={draft.stats} statusCounts={draft.status_counts} />
          </SummarySection>
        )}

        {roleCountCards.length > 0 && (
          <SummarySection title="Role count">
            <OrgDesignRoleCount cards={roleCountCards} entryOption={draft.entryOption} />
          </SummarySection>
        )}

        {!hasFigures && <SbEmpty description="Summary figures aren't available for this design yet." />}
      </SummarySectionsStyled>
    </SummaryTabStyled>
  );
});

OrgDesignSummaryTab.displayName = "OrgDesignSummaryTab";

export default OrgDesignSummaryTab;
